export default "__VITE_ASSET__BGmSdR$R__"